module.exports = __webpack_public_path__ + "media/images/ui__textArrowRightLight--dark-e46ef71c61f08eb89da36dc9391c99d7.png";